import { cacheTypes } from "./cache.types";

const INITIAL_STATE = {
  convsCacheData: {},
};

const cacheReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    /*
      (CONVS_CACHE_DATA) action.payload == {
        convId: "1234-abcd-...",
        conversation: {...}, // The whole 'conversation' object retrieved from backend
        user: {...}, // The whole 'user' object retrieved from backend
      }
    */
    case cacheTypes.CONVS_CACHE_DATA:
      return {
        ...state,
        convsCacheData: {
          ...state.convsCacheData,
          [action.payload.convId]: {
            conversation: action.payload.conversation,
            user: action.payload.user,
          },
        },
      };

    default:
      return state;
  }
};

export default cacheReducer;
